module.exports = __webpack_public_path__ + "static/lavoraconnoi_background-143c439d59e94c2e54903c1cf1e72557.jpg";